import { Injectable, OnDestroy } from '@angular/core';
import { filter, merge, MonoTypeOperatorFunction, Observable, publishReplay, refCount, scan, shareReplay, startWith, Subject, BehaviorSubject } from 'rxjs';
import { IShadowState } from '../interfaces/interfaces';
import { getActionKey, getActionType } from '../utils/device-name-parser';

const SET_ACTION = 'set_val';
const UPDATE_ACTION = 'update_val';
const RESET_ACTION = 'reset';

export interface Action {
  type: string;
  payload?: {
    message: IShadowState;
    entityId: string;
  };
}

export interface MessagesState {
 [key: string]: IShadowState;
}

const initialState: MessagesState = {}

@Injectable({
  providedIn: 'root'
})
export class MqttMessageStorageService implements OnDestroy {

  private actions$: Subject<Action> = new Subject<Action>();

  // private addNewVal$: Observable<Action> = this.actions$.pipe(
  //   this.ofType(SET_ACTION),
  // );

  // private updateVal$: Observable<Action> = this.actions$.pipe(
  //   this.ofType(UPDATE_ACTION),
  // );

  // private dispatcher$: Observable<Action> = merge(this.actions$, this.addNewVal$, this.updateVal$);
  private dispatcher$: Observable<Action> = merge(this.actions$);

  // Store current state in a BehaviorSubject to ensure new subscribers get the current value
  private currentState = new BehaviorSubject<MessagesState>(initialState);
  
  private state$: Observable<MessagesState> = this.dispatcher$.pipe(
    startWith({ type: 'INIT' } as Action), // Emit initial action to trigger scan
    scan((state: MessagesState, action: Action): MessagesState => {
      if (!state) {
        return initialState;
      }

      let newState = state;
      switch (action.type) {
        case SET_ACTION:
          if (action.payload) {
            newState = {...state, [action.payload.entityId]: action.payload.message};
          }
          break;
        case UPDATE_ACTION:
          if (action.payload) {
            newState = {...state, [action.payload.entityId]: action.payload.message};
          }
          break;
        case RESET_ACTION:
          newState = initialState;
          break;
        default:
          newState = state;
      }
      
      // Update BehaviorSubject with new state
      this.currentState.next(newState);
      return newState;
    }, initialState),
    shareReplay(1),
  );

  public items$: Observable<MessagesState> = this.currentState.asObservable();

  constructor() { 
    // Subscribe to state$ to keep currentState updated
    this.state$.subscribe();
  }

  public setValue(entityId: string, value: IShadowState) {
    this.dispatch({
      type: SET_ACTION,
      payload: {
        entityId,
        message: value,
      },
    })
  }

  public update(entityId: string, value: IShadowState) {
    this.dispatch({
      type: UPDATE_ACTION,
      payload: {
        entityId,
        message: value,
      },
    })
  }

  public reset() {
    this.dispatch({
      type: RESET_ACTION,
    })
  }

  public ngOnDestroy(): void {
    this.actions$.complete();
  }

  private dispatch(action: Action) {
    this.actions$.next(action);
  }

  private ofType<T extends Action>(type: string): MonoTypeOperatorFunction<T> {
    return filter((_) => type === _.type);
  }
}


